import React, { useState } from 'react'
import * as st from '~/assets/styl/Location.module.styl'
import { Button, Modal } from '~/components'
import Svg from './svg'
import Walking from '~/assets/svg/A-pe.svg'
import { useLanguage } from '~/hooks'
// import Car from '~/assets/svg/De-carro.svg'

export default function Location() {
  const [modal, setModal] = useState(-1)
  const { t } = useLanguage()
  return (
    <>
      <section className={st.core} id="Localizacao">
        <div className={st.container}>
          <div>
            <h2>
              <span>{t('Location.beiraMar')}</span>
              <span>{t('Location.krumel')}</span>
            </h2>
            <p>{t('Location.theDvert')}</p>
            <h3>{t('Location.theNeighborhood')}</h3>
            <div className={st.links}>
              <Button onClick={() => setModal(0)}>
                {t('Location.button')}
              </Button>
              {/* <Button onClick={() => setModal(1)}>Ir de carro</Button> */}
            </div>
          </div>
          <Svg />
        </div>
      </section>

      <Modal
        open={modal === 0}
        onClose={() => setModal(-1)}
        className={st.modal}
      >
        {(closeProps) => (
          <>
            <button {...closeProps}></button>
            <h3>
              <img src={Walking} width="60" height="60" />
              {t('Location.toGoBike')}
            </h3>
            <ul>
              <li>
                <span>{t('Location.location.name1')}</span>
                <span>{t('Location.location.distance1')}</span>
              </li>
              <li>
                <span>{t('Location.location.name2')}</span>
                <span>{t('Location.location.distance2')}</span>
              </li>
              <li>
                <span>{t('Location.location.name3')}</span>
                <span>{t('Location.location.distance3')}</span>
              </li>
              <li>
                <span>{t('Location.location.name4')}</span>
                <span>{t('Location.location.distance4')}</span>
              </li>
              <li>
                <span>{t('Location.location.name5')}</span>
                <span>{t('Location.location.distance5')}</span>
              </li>
              <li>
                <span>{t('Location.location.name6')}</span>
                <span>{t('Location.location.distance6')}</span>
              </li>
              <li>
                <span>{t('Location.location.name7')}</span>
                <span>{t('Location.location.distance7')}</span>
              </li>
              <li>
                <span>{t('Location.location.name8')}</span>
                <span>{t('Location.location.distance8')}</span>
              </li>
              <li>
                <span>{t('Location.location.name9')}</span>
                <span>{t('Location.location.distance9')}</span>
              </li>
            </ul>
          </>
        )}
      </Modal>

      {/* <Modal
        open={modal === 1}
        onClose={() => setModal(-1)}
        className={st.modal}
      >
        {(closeProps) => (
          <>
            <button {...closeProps}></button>
            <h3>
              <img src={Car} width="60" height="60" />
              Para ir de carro
            </h3>
            <ul>
              <li>
                <span>Beiramar do estreito</span>
                <span>1 km</span>
              </li>
              <li>
                <span>Beiramar do estreito</span>
                <span>1 km</span>
              </li>
              <li>
                <span>Beiramar do estreito</span>
                <span>1 km</span>
              </li>
            </ul>
          </>
        )}
      </Modal> */}
    </>
  )
}
